import {
  FETCH_PENALTIES_SUCCESS,
  FETCH_PENALTY_SUCCESS,
} from '../../constants/ActionTypes';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PENALTIES_SUCCESS:
      return { ...state, index: action.payload };

    case FETCH_PENALTY_SUCCESS:
      return { ...state, show: action.payload };

    default:
      return state;
  }
}
